// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 900px) {
  .wizard-image {
    display: none;
  }

  .summary-container {
    width: 100%;
  }

}

.summary-container {
  gap: 1.5em;
  max-width: 670px;
  min-width: 600px;
}
/* @media screen and (min-width:900px) and (max-width: 1024px) {
  .newflexcol,.flexcol{width: 46%;}

} */


.wizard-image img {
  max-width: 100%;
  margin-left: -25%;
  width: 550px;
}

.slideInAnimation {
  animation: slidein 4s forwards;
}

.slideOutAnimation {
  animation: slideout 6s forwards;
}


@keyframes slidein {
  100% { right: 250px; }
}


@keyframes slideout {
  0% { right: 250px; }
  100% { right: 50%; }
}


.option-card {
  transition: all 0.3s ease-in-out;
}

.option-card.active {
  border-color: #00af76 !important;
}

.option-card.inactive {
  opacity: 0.7;
}
.option-card.inactive:hover {
  opacity: 1;
}
/* .option-card:hover .svg-icon {
  -webkit-transition: fill 0.3s ease !important;
  transition: fill 0.3s ease !important;
  fill: #fff; }

.option-card:hover {
  background-color: #0078FF !important;
  color: #fff !important;
} */

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/wizard/select-portal/select-portal.component.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;AAEF;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;GAGG;;;AAGH;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EAEE,+BAA+B;AACjC;;;AAGA;EACE,OAAO,YAAY,EAAE;AACvB;;;AAGA;EACE,KAAK,YAAY,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;;AAGA;EAEE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;;;;;;;;GAQG;;AADH,g6EAAg6E","sourcesContent":["@media screen and (max-width: 900px) {\n  .wizard-image {\n    display: none;\n  }\n\n  .summary-container {\n    width: 100%;\n  }\n\n}\n\n.summary-container {\n  gap: 1.5em;\n  max-width: 670px;\n  min-width: 600px;\n}\n/* @media screen and (min-width:900px) and (max-width: 1024px) {\n  .newflexcol,.flexcol{width: 46%;}\n\n} */\n\n\n.wizard-image img {\n  max-width: 100%;\n  margin-left: -25%;\n  width: 550px;\n}\n\n.slideInAnimation {\n  -webkit-animation: slidein 4s forwards;\n  animation: slidein 4s forwards;\n}\n\n.slideOutAnimation {\n  -webkit-animation: slideout 6s forwards;\n  animation: slideout 6s forwards;\n}\n\n\n@keyframes slidein {\n  100% { right: 250px; }\n}\n\n\n@keyframes slideout {\n  0% { right: 250px; }\n  100% { right: 50%; }\n}\n\n\n.option-card {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\n.option-card.active {\n  border-color: #00af76 !important;\n}\n\n.option-card.inactive {\n  opacity: 0.7;\n}\n.option-card.inactive:hover {\n  opacity: 1;\n}\n/* .option-card:hover .svg-icon {\n  -webkit-transition: fill 0.3s ease !important;\n  transition: fill 0.3s ease !important;\n  fill: #fff; }\n\n.option-card:hover {\n  background-color: #0078FF !important;\n  color: #fff !important;\n} */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
